import { ReactNode } from 'react';
import { Permission } from 'components/permissions/Permission';
import { PermissionEnum } from 'components/permissions/PermissionEnums';
import { usePermissions } from 'components/permissions/usePermissions';

interface PermissionsProps {
    children?: ReactNode;
    fallback?: ReactNode;
    allowed?: Permission[] | PermissionEnum[];
}

const Permissions = ({ children, allowed = [], fallback = null }: PermissionsProps) => {
    const { isPermitted } = usePermissions(allowed);

    if (!isPermitted) {
        return <>{fallback}</>;
    }

    return <>{children}</>;
};

export { Permissions };
